import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Button,
  Box,
  Pagination,
  TextField,
  Tooltip,
} from "@mui/material";
import OurLayouts from "../Layouts";
import apiService from "../../services/apiservice";
import { FaEye, FaFilter } from "react-icons/fa";
import { Sidebar } from "primereact/sidebar";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import AddService from "./addService";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { InputText } from "primereact/inputtext";
import PatientSearch from "../Shared/patientSearch";
import { Dropdown } from "primereact/dropdown";
import { TiExport } from "react-icons/ti";
import { toast } from "react-toastify";
import { ProgressSpinner } from "primereact/progressspinner";
import { useGlobalContext } from "../../GlobalContext";
import Divider from "@mui/material/Divider";

const serviceListOptions = [
  { id: 8, value: "IPD" },
  { id: 9, value: "OPD" },
  { id: 10, value: "Investigation" },
  { id: 11, value: "Day Care" },
    { id: 12, value: 'Physiotherapy' },

];

const billingStatusList = [
  { value: 1, name: "Billing Uploaded" },
  { value: 3, name: "Billing Completed" },
  { value: 2, name: "Billing Done" },
  { value: 4, name: "Billing Approved" },
  { value: 5, name: "Billing Rejected" },
  { value: 6, name: "Billing Rejected by Finance" },
];

const hospitalizationTypeMap = {
  8: [
    { id: 1, value: "General Surgery" },
    { id: 2, value: "Oncology" },
    { id: 3, value: "Neurology" },
    { id: 4, value: "Orthopedic" },
    { id: 5, value: "Urology" },
    { id: 6, value: "Cardiology" },
    { id: 7, value: "ENT" },
    { id: 8, value: "Gynecology" },
    { id: 10, value: "Opthalmology" },
    { id: 11, value: "General Medicine" },
    { id: 15, value: "Nephrology" },
  ],
  9: [{ id: 12, value: "OPD Others" }],
  10: [{ id: 13, value: "Investigation Others" }],
  11: [{ id: 14, value: "Day Care Others" }],
    12: [{ id: 16, value: "Physiotherapy" }]

};

const serviceTypeOptions = [
  { id: 8, value: "IPD" },
  { id: 9, value: "OPD" },
  { id: 10, value: "Investigation" },
  { id: 11, value: "Day Care" },
    { id: 12, value: 'Physiotherapy' },

];

const campLeadOptions = [
  { id: 1, label: "Yes" },
  { id: 0, label: "No" },
];

const traumaStatusOptions = [
  { id: 0, value: "No" },
  { id: 1, value: "Yes (Waiting for Approval)" },
  { id: 2, value: "Yes (Approved)" },
  { id: 3, value: "Yes (Rejected)" },
];

const getTraumaLabel = (status) => {
  const labels = {
    0: { main: "No", sub: "" },
    1: { main: "Yes", sub: "Waiting for Approval" },
    2: { main: "Yes", sub: "Approved" },
    3: { main: "Yes", sub: "Rejected" }
  };
  return labels[status] || { main: "", sub: "" };
};

const getTraumaColor = (status) => {
  const colors = {
    1: "orange",
    2: "green",
    3: "red"
  };
  return colors[status] || "black";
};

const getBillingStyle = (status) => {
  const colorMap = {
    1: "#ECAC09",
    2: "violet",
    3: "#7225EF",
    4: "#299F5D",
    5: "#DD0000",
    6: "#DD0000"
  };
  return { color: colorMap[status] || "#3D3BA4" };
};

const getBillingStatusLabel = (status) => {
  const labels = {
    1: "Billing Uploaded",
    2: "Billing Done",
    3: "Billing Completed",
    4: "Billing Approved",
    5: "Billing Rejected",
    6: "Billing Rejected by Finance"
  };
  return labels[status] || "";
};

const formatDate = (date) => {
  if (!date) return "";
  return moment(date).format("MM/DD/YYYY");
};

const parseDate = (dateString) => {
  if (!dateString) return null;
  return moment(dateString, "MM/DD/YYYY").isValid() ? new Date(dateString) : null;
};

const convertUTCToLocal = (date, format = "MM/DD/YYYY") => {
  if (!date) return "";
  const localTime = moment.utc(date).toDate();
  return moment(localTime).format(format);
};

const applyPatientFilters = (payload) => {
  if (payload.patientId) {
    delete payload.patientName;
  } else {
    delete payload.patientName;
    delete payload.patientId;
  }
};

const applyDateFilters = (payload, currentFilter) => {
  const fromDate = currentFilter.fromDate
    ? convertUTCToLocal(new Date(currentFilter.fromDate))
    : convertUTCToLocal(new Date());
  const toDate = currentFilter.toDate
    ? convertUTCToLocal(new Date(currentFilter.toDate))
    : convertUTCToLocal(new Date());
  payload.fromDate = fromDate;
  payload.toDate = toDate;
};

const ServicesList = () => {
  const [loading, setLoading] = useState(false);
  const [reject, setReject] = useState(false);
  const [addService, setAddService] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const { exporting, setExporting } = useGlobalContext();
  const [serviceList, setServiceList] = useState([]);
  const [page, setPage] = useState(1);
  const [viewEnquiry, setViewEnquiry] = useState(false);
  const [patientSearch, setPatientSearch] = useState(false);
  const [hospitalList, setHospitalList] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [subtypedropdownList, setSubtypedropdownList] = useState([]);
  const [billingView, setBillingView] = useState(false);
  const [billingData, setBillingData] = useState([]);
  
  const filterRef = useRef({
    fromDate: formatDate(new Date()),
    toDate: formatDate(new Date()),
  });
  
  const [filterObj, setFilterObj] = useState(filterRef.current);
  const searchTriggerRef = useRef(true);

  const userObj = JSON.parse(localStorage.getItem("loginObj"));
  const roleCode = localStorage.getItem("userRole");
  const location = roleCode === "PRADMIN" ? JSON.parse(localStorage.getItem("location")) : null;

  const buildPayload = useCallback((currentFilter, pageNumber) => {
    const fromDate = currentFilter.fromDate
      ? convertUTCToLocal(new Date(currentFilter.fromDate))
      : convertUTCToLocal(new Date());
    const toDate = currentFilter.toDate
      ? convertUTCToLocal(new Date(currentFilter.toDate))
      : convertUTCToLocal(new Date());

    const payload = {
      serviceStatus: 1,
      fromDate,
      toDate,
      roleCode,
      pageNumber,
    };

    if (currentFilter?.campLead) {
      payload.campLead = currentFilter.campLead;
    }
    if (currentFilter.billingStatus && activeTab === 1) {
      payload.billingStatus = currentFilter.billingStatus;
    }
    if (activeTab === 1) {
      payload.allBillingFlag = 1;
    }
    if (roleCode === "PRADMIN" && location?.locationId) {
      payload.locationId = location.locationId;
    }

    const mergedPayload = { ...payload, ...currentFilter };
    applyDateFilters(mergedPayload, currentFilter);

    if (currentFilter.billingStatus && activeTab === 0) {
      delete mergedPayload.billingStatus;
    }
    if (mergedPayload.billingStatus === null) {
      delete mergedPayload.billingStatus;
    }

    applyPatientFilters(mergedPayload);

    if (mergedPayload.serviceEnquiryId) {
      delete mergedPayload.fromDate;
      delete mergedPayload.toDate;
    }
    if (!mergedPayload.nameSearch) {
      delete mergedPayload.nameSearch;
    }

    return Object.fromEntries(Object.entries(mergedPayload).filter(([_, value]) => value !== null));
  }, [activeTab, roleCode, location]);

  const processServiceList = useCallback((list) => {
    return list.map(element => ({
      ...element,
      mciPercentage: (((element?.mci || 0) / (element?.gross || 1)) * 100).toFixed(2),
      gmvPercentage: ((element?.curebayFee / (element?.gross || 1)) * 100).toFixed(2),
      netSalesPercentage: (((element?.yieldAmount || 0) / (element?.curebayFee || 1)) * 100).toFixed(2),
      doctorSharePercentage: (((element?.doctorShare || 0) / (element?.curebayFee || 1)) * 100).toFixed(2),
    }));
  }, []);

  const getServicesBillList = useCallback(async () => {
    if (!searchTriggerRef.current) return;
    
    setServiceList([]);
    
    const currentFilter = filterRef.current;
    const payload = buildPayload(currentFilter, page);

    setLoading(true);
    setViewEnquiry(false);

    try {
      const res = await apiService.getServicesBillList(payload);
      if (res.data.responseCode === '200') {
        const processedList = processServiceList(res.data.successList);
        setServiceList(processedList);
        setLoading(false);
        searchTriggerRef.current = false;
      }
    } catch (error) {
      console.error("Error fetching service list:", error);
      setLoading(false);
      setViewEnquiry(false);
      searchTriggerRef.current = false;
    }
  }, [buildPayload, page, processServiceList]);

  const toggleSidebar = useCallback(() => {
    setAddService(prev => !prev);
  }, []);

  const toggleSidebarFilter = useCallback(() => {
    setPatientSearch(prev => !prev);
  }, []);

  const handleSelectedData = useCallback(({ code, name }) => {
    const newFilter = {
      ...filterRef.current,
      patientId: code,
      patientName: name,
      nameSearch: ""
    };
    
    setFilterObj(newFilter);
    filterRef.current = newFilter;
  }, []);

  const updateFilter = useCallback((name, value) => {
    let updatedValue = value;
    
    if (name === "fromDate" || name === "toDate") {
      updatedValue = formatDate(value);
    }
    
    setFilterObj(prev => {
      const newFilter = {
        ...prev,
        [name]: updatedValue,
      };
      
      if (name === "nameSearch" && value) {
        newFilter.patientId = "";
        newFilter.patientName = "";
      }
      
      filterRef.current = newFilter;
      
      return newFilter;
    });
  }, []);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    updateFilter(name, value);
  }, [updateFilter]);

  const handleChangeFilter = useCallback((e) => {
    const { name, value } = e.target;
    updateFilter(name, value);
  }, [updateFilter]);

  const executeSearch = useCallback(() => {
    filterRef.current = { ...filterObj };
    setPage(1);
    searchTriggerRef.current = true;
    getServicesBillList();
  }, [filterObj, getServicesBillList]);

  const refresh = useCallback(() => {
    setPage(1);
    const resetFilter = {
      fromDate: formatDate(new Date()),
      toDate: formatDate(new Date()),
    };
    
    setFilterObj(resetFilter);
    filterRef.current = resetFilter;
    
    searchTriggerRef.current = true;
    getServicesBillList();
  }, [getServicesBillList]);

  const handlePageChange = useCallback((event, value) => {
    setPage(value);
    searchTriggerRef.current = true;
  }, []);

  const handleClick = useCallback((service) => {
    setSelectedRow(service);
    setAddService(true);
  }, []);

  const handleClickReject = useCallback((data) => {
    setSelectedRow({ ...data });
    setReject(true);
  }, []);

  const rejectTionUpdate = useCallback((e, data) => {
    const updatedData = serviceList.map((item) => {
      if (item.id === data.id) {
        return { ...item, reasonForReject: e.target.value };
      }
      return item;
    });
    setServiceList(updatedData);
    setSelectedRow(prev => ({ ...prev, reasonForReject: e.target.value }));
  }, [serviceList]);

  const validateRejectionReason = useCallback((service) => {
    if (!service?.reasonForReject || service?.reasonForReject == null) {
      setReject(true);
      const updatedData = serviceList.map((item) => {
        if (item.id === service.id) {
          return { ...item, reject: true };
        }
        return item;
      });
      setServiceList(updatedData);
      setLoading(false);
      toast.error("Please enter reason for rejection.");
      return false;
    }
    return true;
  }, [serviceList]);

  const getBillingStatusByRole = useCallback(() => {
    if (roleCode === 'GROUPPRADMIN') return 2;
    if (roleCode === 'CE') return 1;
    if (roleCode === 'ACCADMIN') return 3;
    return 2;
  }, [roleCode]);

  const handleApprovalAction = useCallback(async (service, action) => {
    setSelectedRow(service);
    setLoading(true);

    if (action === "R") {
      const isValid = validateRejectionReason(service);
      if (!isValid) return;
    }

    if (action === "A") {
      const updatedData = serviceList.map((item) => {
        if (item.id === service.id) {
          return { ...item, reject: false };
        }
        return item;
      });
      setServiceList(updatedData);
    }

    const billingStatus = getBillingStatusByRole();

    const payload = {
      id: service.id,
      billingStatus: billingStatus,
      modifiedBy: userObj.user.code,
      userRoleCode: roleCode
    };

    if (action === "R") {
      payload.billingStatus = 6;
      payload.reasonForReject = selectedRow.reasonForReject;
    }

    try {
      let apiCall;
      if (roleCode === 'ACCADMIN') {
        apiCall = action === "R"
          ? apiService.rejectfromFinance(payload)
          : apiService.approvefromFinance(payload);
      } else {
        apiCall = apiService.apporoveOthers(payload);
      }

      const res = await apiCall;

      if (res.data.responseCode === '200') {
        toast.success(res.data.responseMessage);
        setServiceList([]);
        setReject(false);
        searchTriggerRef.current = true;
        getServicesBillList();
      } else {
        toast.error(res.data.responseMessage);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error processing approval:", error);
      toast.error("An error occurred");
      setLoading(false);
    }
  }, [roleCode, selectedRow.reasonForReject, userObj.user.code, getServicesBillList, serviceList, validateRejectionReason, getBillingStatusByRole]);

  const handleApproveClick = useCallback((service, action) => {
    return handleApprovalAction(service, action);
  }, [handleApprovalAction]);

  const handleRejectClick = useCallback((service, action) => {
    return handleApprovalAction(service, action);
  }, [handleApprovalAction]);

  const getHeader = useCallback(() => (
    <div className="font-poppins text-primary text-xl font-bold leading-6 tracking-normal text-left">
      Edit Service
    </div>
  ), []);

  const handleClickFilter = useCallback(() => {
    setViewEnquiry(true);
  }, []);

  const getHospitalList = useCallback(async () => {
    const payload = { status: 1, HospitalType: "H" };
    try {
      const res = await apiService.getHospitalList(payload);
      const formatted = res.data.successObject.map(element => ({
        ...element,
        hospitalLocationNames: `${element.hospitalName} (${element.name})`,
      }));
      setHospitalList(formatted);
    } catch (error) {
      console.error("Error fetching hospital list:", error);
    }
  }, []);

  const getSubList = useCallback(async () => {
    if (!filterObj?.hospitalizationTypeId || !filterObj?.serviceType) return;
    
    const payload = {
      serviceType: filterObj.serviceType,
      hosId: filterObj.hospitalizationTypeId,
    };
    
    try {
      const res = await apiService.getHosSubType(payload);
      if (res.data?.data?.length) {
        setSubtypedropdownList(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching hospitalization subtypes:", error);
    }
  }, [filterObj?.hospitalizationTypeId, filterObj?.serviceType]);

  const handleChangeTab = useCallback((tab) => {
    if (tab === 0) {
      setFilterObj(prev => {
        const newFilter = { ...prev };
        delete newFilter.billingStatus;
        return newFilter;
      });
    }
    setActiveTab(tab);
    setPage(1);
    searchTriggerRef.current = true;
  }, []);

  const handleCancel = useCallback(() => {
    const resetFilter = {
      fromDate: formatDate(new Date()),
      toDate: formatDate(new Date()),
    };
    
    setFilterObj(resetFilter);
    filterRef.current = resetFilter;
  }, []);

  const buildExportPayload = useCallback(() => {
    const currentFilter = filterRef.current;
    
    const payload = {
      serviceStatus: 1,
      fromDate: currentFilter.fromDate ? convertUTCToLocal(new Date(currentFilter.fromDate)) : convertUTCToLocal(new Date()),
      toDate: currentFilter.toDate ? convertUTCToLocal(new Date(currentFilter.toDate)) : convertUTCToLocal(new Date()),
      roleCode: roleCode,
    };

    if (activeTab === 1) {
      payload.allBillingFlag = 1;
    }
    if (roleCode === "PRADMIN" && location?.locationId) {
      payload.locationId = location.locationId;
    }

    const mergedPayload = { ...payload, ...currentFilter };
    mergedPayload.fromDate = currentFilter.fromDate ? convertUTCToLocal(new Date(currentFilter.fromDate)) : convertUTCToLocal(new Date());
    mergedPayload.toDate = currentFilter.toDate ? convertUTCToLocal(new Date(currentFilter.toDate)) : convertUTCToLocal(new Date());

    if (mergedPayload.billingStatus === null) {
      delete mergedPayload.billingStatus;
    }
    if (activeTab === 0) {
      delete mergedPayload.serviceStatus;
    }
    if (!mergedPayload.patientId) {
      delete mergedPayload.patientName;
      delete mergedPayload.patientId;
    }
    if (mergedPayload.patientId) {
      delete mergedPayload.patientName;
    }
    if (!mergedPayload.nameSearch) {
      delete mergedPayload.nameSearch;
    }

    return mergedPayload;
  }, [activeTab, roleCode, location]);

  const exportToExcel = useCallback(async () => {
    setExporting(true);
    
    const payload = buildExportPayload();

    try {
      await apiService.exportServiceList(payload);
    } catch (error) {
      console.error("Error exporting service list:", error);
      toast.error("Error exporting data");
    } finally {
      setExporting(false);
    }
  }, [buildExportPayload, setExporting]);

  const onViewPastBilling = useCallback(async (data) => {
    const payload = {
      patientId: data?.patientId,
      pageNumber: 1,
    };
    
    setLoading(true);
    try {
      const res = await apiService.getServicesBillListByPatient(payload);
      if (!res.data.successList || res.data.successList.length === 0) {
        toast("No data found");
      } else {
        const dataWithPagination = res.data.successList;
        dataWithPagination[0].pagination = res.data.pagination;
        setBillingData(dataWithPagination);
        setBillingView(true);
      }
    } catch (error) {
      console.error("Error fetching past billing:", error);
      toast.error("Error fetching data");
    } finally {
      setLoading(false);
    }
  }, []);

  const openUrl = useCallback(async (service) => {
    if (!service?.uploadBillName) return;
    
    try {
      const res = await apiService.openFilesBucket(service.uploadBillName);
      if (res.data.responseCode === '200') {
        globalThis.open(res.data.successObject, "_blank");
      }
    } catch (error) {
      console.error("Error opening file:", error);
      toast.error("Error opening file");
    }
  }, []);


  const onHideBilling = useCallback(() => {
    setBillingView(false);
  }, []);

  useEffect(() => {
    getHospitalList();
    searchTriggerRef.current = true;
  }, [getHospitalList]);

  useEffect(() => {
    if (searchTriggerRef.current) {
      getServicesBillList();
    }
  }, [searchTriggerRef.current, getServicesBillList]);

  useEffect(() => {
    if (filterObj?.serviceType) {
      const newFilter = {
        ...filterObj,
        hospitalizationTypeId: null,
        procedureId: null,
      };
      setFilterObj(newFilter);
      filterRef.current = newFilter;
      setSubtypedropdownList([]);
    }
  }, [filterObj?.serviceType]);

  useEffect(() => {
    getSubList();
  }, [filterObj?.hospitalizationTypeId, filterObj?.serviceType, getSubList]);

  const renderTraumaStatus = useCallback((traumaStatus) => {
    const trauma = getTraumaLabel(traumaStatus);
    if (!trauma.main) return null;
    
    return (
      <>
        <span style={{ color: "black" }}>{trauma.main}</span>
        {trauma.sub && (
          <>
            {" "}
            (<span style={{ color: getTraumaColor(traumaStatus) }}>
              {trauma.sub}
            </span>)
          </>
        )}
      </>
    );
  }, []);

  const renderPatientSearchInput = () => (
    <div>
      <label htmlFor="patientSelect">Select Patient</label>
      <div className="relative">
        <InputText
          id="patientName"
          className="border border-gray-300 rounded-md p-2 pr-10 w-full"
          value={filterObj?.patientName || ''}
          name="patientName"
          placeholder="Click icon to search patients"
          readOnly
        />
        <button
          type="button"
          className="absolute inset-y-0 right-0 flex items-center pr-2 cursor-pointer bg-transparent border-0"
          onClick={toggleSidebarFilter}
          onKeyPress={(e) => e.key === 'Enter' && toggleSidebarFilter()}
          aria-label="Search patients"
          tabIndex={0}
        >
          <svg
            className="w-5 h-5 text-gray-400"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M21 21l-5.2-5.2"></path>
            <circle cx="10" cy="10" r="7"></circle>
          </svg>
        </button>
      </div>
    </div>
  );

  const renderFilterSidebar = () => (
    <div className="grid mt-4 grid-cols-2 gap-4">
      <div>
        <label htmlFor="dob">From Date</label>
        <Calendar
          id="date"
          className="border border-gray-300 rounded-md p-2 w-full"
          dateFormat="dd/mm/yy"
          style={{ height: "40px" }}
          onChange={handleChangeFilter}
          name="fromDate"
          value={parseDate(filterObj?.fromDate)}
          placeholder="Select From Date"
          maxDate={parseDate(filterObj.toDate)}
        />
      </div>
      <div>
        <label htmlFor="dob">To Date</label>
        <Calendar
          id="date"
          className="border border-gray-300 rounded-md p-2 w-full"
          dateFormat="dd/mm/yy"
          style={{ height: "40px" }}
          onChange={handleChangeFilter}
          name="toDate"
          value={parseDate(filterObj?.toDate)}
          placeholder="Select To Date"
          minDate={parseDate(filterObj.fromDate)}
        />
      </div>
      <div>
        <label htmlFor="nameSearch">Patient Name</label>
        <div className="relative">
          <input
            id="nameSearch"
            name="nameSearch"
            className="border border-gray-300 rounded-md p-2 pr-10 w-full"
            onChange={handleChangeFilter}
            value={filterObj?.nameSearch || ''}
            placeholder="Search by patient name"
            type="text"
          />
        </div>
      </div>
      {renderPatientSearchInput()}
      <div>
        <label htmlFor="name">Preferred Hospitals</label>
        <Dropdown
          optionLabel="hospitalLocationNames"
          placeholder="Select Preferred Hospitals"
          options={hospitalList}
          name="hospitalId"
          value={filterObj?.hospitalId}
          optionValue="hospitalCode"
          style={{ height: "45px" }}
          className="border border-gray-300 rounded-md p-1 w-full"
          onChange={handleChangeFilter}
          filter
        />
      </div>
      <div>
        <label htmlFor="serviceEnquiryId">Enquiry Id</label>
        <div className="relative">
          <InputText
            id="serviceEnquiryId"
            name="serviceEnquiryId"
            className="border border-gray-300 rounded-md p-2 pr-10 w-full"
            onChange={handleChangeFilter}
            value={filterObj?.serviceEnquiryId || ''}
            type="number"
            pattern="\d*"
            placeholder="Search for Enquiry Id"
          />
        </div>
      </div>
      <div>
        <label htmlFor="name">Service Type</label>
        <Dropdown
          value={filterObj?.serviceType || ''}
          options={serviceTypeOptions}
          optionLabel="value"
          placeholder="Select a Procedure"
          optionValue="id"
          name="serviceType"
          className="border border-gray-300 rounded-md w-full"
          onChange={handleChangeFilter}
          filter
        />
      </div>
      {filterObj?.serviceType && (
        <div>
          <label htmlFor="name">Hospitalization Type</label>
          <Dropdown
            optionLabel="value"
            placeholder="Select Hospitalization Type"
            options={hospitalizationTypeMap[filterObj?.serviceType] || []}
            name="hospitalizationTypeId"
            value={filterObj?.hospitalizationTypeId || ''}
            optionValue="id"
            style={{ height: "45px" }}
            className="border border-gray-300 rounded-md p-1 w-full"
            onChange={handleChangeFilter}
            filter
          />
        </div>
      )}
      {filterObj?.hospitalizationTypeId && (
        <div>
          <label htmlFor="name">Hospitalization Subtype</label>
          <Dropdown
            optionLabel="hospitalizationSubType"
            placeholder="Select Hospitalization Subtype"
            options={subtypedropdownList || []}
            name="procedureId"
            value={filterObj?.procedureId || ''}
            optionValue="hospitalizationSubTypeId"
            style={{ height: "45px" }}
            className="border border-gray-300 rounded-md p-1 w-full"
            onChange={handleChangeFilter}
            filter
          />
        </div>
      )}
      <div>
        <label htmlFor="name">Trauma Status</label>
        <Dropdown
          value={filterObj?.traumaStatus || ''}
          options={traumaStatusOptions}
          optionLabel="value"
          placeholder="Select Trauma Status"
          optionValue="id"
          name="traumaStatus"
          className="border border-gray-300 rounded-md w-full"
          onChange={handleChangeFilter}
          filter
        />
      </div>
      {activeTab !== 0 && (
        <>
          <div>
            <label htmlFor="name">Billing Status</label>
            <Dropdown
              value={filterObj?.billingStatus || ''}
              options={billingStatusList}
              optionLabel="name"
              placeholder="Select Billing Status"
              optionValue="value"
              name="billingStatus"
              className="border border-gray-300 rounded-md w-full"
              onChange={handleChangeFilter}
              filter
            />
          </div>
          <div>
            <label htmlFor="name">CAMP LEAD</label>
            <Dropdown
              optionLabel="label"
              placeholder="Select Camp lead or Not"
              options={campLeadOptions}
              value={filterObj?.campLead}
              optionValue="id"
              className="border border-gray-300 rounded-md w-full"
              onChange={handleChangeFilter}
              name="campLead"
              filter
            />
          </div>
        </>
      )}
      <div className="grid mt-36 ml-12 grid-cols-2 gap-4">
        <div>
          <button
            className="h-9 bg-[#004172] text-white rounded-md w-full"
            onClick={() => {
              filterRef.current = { ...filterObj };
              setViewEnquiry(false);
              setPage(1);
              searchTriggerRef.current = true;
              getServicesBillList();
            }}
          >
            Ok
          </button>
        </div>
        <div>
          <button
            className="h-9 border border-[#004172] text-[#004172] font-bold font-monospace rounded-md w-full"
            onClick={() => {
              handleCancel();
            }}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <OurLayouts>
      <Backdrop
        sx={{ color: "#FFFFFF", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress size={80} color="inherit" />
      </Backdrop>
      <div>
        <Sidebar
          style={{ width: "60%", borderBottom: "1px solid #ccc" }}
          dismissable={false}
          visible={viewEnquiry}
          header="Filter Service"
          centered
          onHide={() => setViewEnquiry(false)}
          position="right"
        >
          {renderFilterSidebar()}
        </Sidebar>
        <Sidebar
          style={{ width: "60%", borderBottom: "1px solid #ccc" }}
          dismissable={false}
          visible={addService}
          header={getHeader()}
          centered
          onHide={toggleSidebar}
          position="right"
        >
          <div>
            <AddService
              selected={selectedRow}
              tab={activeTab}
              mode="Edit"
              onClose={() => {
                toggleSidebar();
                searchTriggerRef.current = true;
              }}
            />
          </div>
        </Sidebar>
      </div>
      <div className="flex flex-col w-full mt-[7rem] overflow-auto">
        <div className="flex justify-between mt-[3rem]">
          <div>
            <h1 className="text-2xl text-primary font-semibold">
              Service List
            </h1>
          </div>
          <div className="flex border h-10 rounded-md pt-1 pb-1 mr-12 justify-items-center">
            <div className="flex mx-2 border-r-2">
              <Button className="flex gap-1" onClick={handleClickFilter}>
                <FaFilter className="text-primary" />
                <h6 className="text-primary">Filter</h6>
              </Button>
            </div>
            <div className="flex mx-1">
              <Button
                className="flex gap-1"
                onClick={exportToExcel}
                disabled={exporting}
              >
                <TiExport
                  className="text-2xl"
                  style={{ color: exporting ? "green" : "#004172" }}
                />
                <h6 style={{ color: exporting ? "green" : "#004172" }}>
                  {exporting ? "Downloading..." : "Export Excel"}
                </h6>
              </Button>
              {exporting && (
                <ProgressSpinner
                  style={{ width: "20px", height: "20px" }}
                  strokeWidth="8"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                />
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center mt-4 gap-2 mr-10">
          {activeTab !== 0 && (
            <div>
              <Dropdown
                value={filterObj?.billingStatus || ''}
                options={billingStatusList}
                optionLabel="name"
                placeholder="Select Billing Status"
                optionValue="value"
                name="billingStatus"
                className="border border-gray-300 rounded-md w-full"
                onChange={handleChange}
                filter
              />
            </div>
          )}
          <div>
            <Calendar
              id="fromDate"
              className="border border-gray-300 rounded-md p-2"
              placeholder="Select FromDate"
              onChange={handleChange}
              value={parseDate(filterObj?.fromDate)}
              name="fromDate"
              dateFormat="dd/mm/yy"
              style={{ height: "40px" }}
              maxDate={parseDate(filterObj.toDate)}
            />
          </div>
          <div>
            <Calendar
              id="toDate"
              className="border border-gray-300 rounded-md p-2"
              name="toDate"
              placeholder="Select ToDate"
              onChange={handleChange}
              value={parseDate(filterObj?.toDate)}
              dateFormat="dd/mm/yy"
              style={{ height: "40px" }}
              minDate={parseDate(filterObj.fromDate)}
            />
          </div>
          <button
            className="w-32 h-9 bg-[#004172] text-white rounded-full"
            onClick={executeSearch}
          >
            Search
          </button>
          <button
            className="w-32 h-9 bg-white text-[#004172] rounded-full border border-[#004172]"
            onClick={refresh}
          >
            Refresh
          </button>
        </div>
        <div
          className="w-[99%] mt-8 rounded-[5px]"
          style={{ boxShadow: "0px 8px 25px 0px rgba(0, 0, 0, 0.06)" }}
        >
          <Tabs value={activeTab} onChange={(event, newValue) => handleChangeTab(newValue)}>
            <Tab label={<span style={{ fontWeight: "bold" }}>My Service</span>} />
            <Tab label={<span style={{ fontWeight: "bold" }}>ALL</span>} />
          </Tabs>
          <TableContainer
            component={Paper}
            className="print-table"
            style={{ width: "100%", overflowX: "auto" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {roleCode === "ACCADMIN" && activeTab === 0 && (
                    <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>
                      Approval
                    </TableCell>
                  )}
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Enquiry ID</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Enquiry Date</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Billing Date</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Billing Remark</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Discharge Date</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Date Difference</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Patient ID</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Patient Name</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Hospital</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Payment Type</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Gross</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>MCI</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>GMV</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Net Sales</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>MCI %</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>GMV %</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Net Sales %</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>View Bill</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Billing Details</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Referral Type</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Surgeon Share</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Hospitalization SubType</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Billing Status</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Trauma</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Eclinic Name</TableCell>
                  <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Camp</TableCell>
                  {(roleCode === "GROUPPRADMIN" || roleCode === "ACCADMIN") && (
                    <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Reason</TableCell>
                  )}
                  {roleCode !== "CE" && (
                    <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Action</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {serviceList.map((service) => {
                  const dischargeDateHighlight = service.dischargeDateHighlight;
                  let backgroundColor = '';
                  if (dischargeDateHighlight === 1) {
                    backgroundColor = 'lightgoldenrodyellow';
                  } else if (dischargeDateHighlight === 2) {
                    backgroundColor = 'gold';
                  } else if (dischargeDateHighlight === 3) {
                    backgroundColor = 'red';
                  }
                  
                  return (
                    <TableRow key={`${service.patientId}-${service.id}`} style={{ backgroundColor }}>
                      {roleCode === "ACCADMIN" && activeTab === 0 && (
                        <TableCell style={{ fontSize: "12px", fontWeight: 500 }}>
                          <div>
                            <button
                              className="h-9 w-28 bg-[#004172] text-white rounded-md"
                              onClick={() => handleApproveClick(service, "A")}
                            >
                              Approve
                            </button>
                            <button
                              className="mt-1 w-28 h-9 border border-[#004172] bg-white text-black rounded-md"
                              onClick={() => handleRejectClick(service, "R")}
                            >
                              Reject
                            </button>
                          </div>
                        </TableCell>
                      )}
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.serviceEnquiryId}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>
                        {moment(service.enquiryDate).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>
                        {moment(service.procedureDate).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500, maxWidth: "150px" }}>
                        {service.billingRemark ? (
                          <Tooltip title={service.billingRemark} arrow placement="top">
                            <span
                              style={{
                                display: "inline-block",
                                maxWidth: "150px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                verticalAlign: "middle",
                                cursor: "pointer",
                              }}
                            >
                              {service.billingRemark}
                            </span>
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>
                        {moment(service.admissionToDate).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.dischargeDays}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.patientId}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.patientName}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.hospitalName}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.paymentMode}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.gross}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.mci}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.curebayFee}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.yieldAmount}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.mciPercentage}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.gmvPercentage}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.netSalesPercentage}</TableCell>
                      <TableCell>
                        <button
                          type="button"
                          onClick={() => openUrl(service)}
                          className="bg-transparent border-0 cursor-pointer"
                          aria-label="View bill"
                        >
                          <FaEye />
                        </button>
                      </TableCell>
                      <TableCell>
                        <button
                          type="button"
                          onClick={() => onViewPastBilling(service)}
                          className="bg-transparent border-0 cursor-pointer"
                          aria-label="View billing details"
                        >
                          <FaEye />
                        </button>
                      </TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>
                        {service?.referral === 0 ? "Referral" : "Non-Referral"}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service?.doctorShare}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.procedureName}</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 500 }}>
                        <span style={getBillingStyle(service.billingStatus)}>
                          {getBillingStatusLabel(service.billingStatus)}
                        </span>
                      </TableCell>
                      <TableCell>{renderTraumaStatus(service.traumaStatus)}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.cheCenterName}</TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>
                        {service?.campLead === 0 ? "No" : "Yes"}
                      </TableCell>
                      {(roleCode === "GROUPPRADMIN" || roleCode === "ACCADMIN") && (
                        <TableCell>
                          {service?.reasonForReject && (
                            <button
                              type="button"
                              onClick={() => handleClickReject(service)}
                              className="bg-transparent border-0 cursor-pointer"
                              aria-label="View rejection reason"
                            >
                              <FaEye />
                            </button>
                          )}
                        </TableCell>
                      )}
                      {roleCode !== "CE" && (
                        <TableCell>
                          <button
                            className="w-32 h-9 bg-[#004172] text-white rounded-full"
                            onClick={() => handleClick(service)}
                          >
                            Edit
                          </button>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}>
            <Pagination
              count={Math.ceil(serviceList[0]?.pagination?.totalRecords / 10) || 1}
              page={page}
              color="secondary"
              onChange={handlePageChange}
            />
          </Box>
        </div>
        <Sidebar
          style={{ width: "80%", borderBottom: "1px solid #ccc" }}
          dismissable={false}
          visible={billingView}
          onHide={onHideBilling}
          position="right"
        >
          {billingData?.length > 0 && (
            <div>
              <div className="w-118 h-10 top-98 left-47 bg-lightBlue bg-opacity-5.5 overflow-auto">
                <Typography className="font-poppins text-base font-semibold leading-6 mt-2 ml-2 text-left">
                  Patient Name - {billingData[0].patientName}
                </Typography>
              </div>
              <div className="w-118 h-10 top-98 left-47 bg-lightBlue bg-opacity-5.5 overflow-auto">
                <Typography className="font-poppins text-base font-semibold leading-6 mt-2 ml-2 text-left">
                  Total Billing - {billingData[0]?.pagination?.totalRecords || 0}
                </Typography>
              </div>
              <TableContainer component={Paper} style={{ width: "100%", height: "36vw", overflowX: "auto" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Enquiry ID</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Enquiry Date</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Billing Date</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Billing Remark</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Patient ID</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Patient Name</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Procedure Name</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Preferred Hospital & Clinic</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Doctor Name</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Gross Amount</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>MCI</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Net Sale</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Total Amount</TableCell>
                      {roleCode === 'ACCADMIN' && (
                        <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Updated By</TableCell>
                      )}
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Billing Status</TableCell>
                      <TableCell style={{ fontSize: "15px", fontWeight: 600 }}>Trauma</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {billingData.map((service) => (
                      <TableRow key={service.id}>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.serviceEnquiryId}</TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>
                          {moment(service.enquiryDate).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>
                          {moment(service.procedureDate).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500, maxWidth: "150px" }}>
                          {service.billingRemark ? (
                            <Tooltip title={service.billingRemark} arrow placement="top">
                              <span
                                style={{
                                  display: "inline-block",
                                  maxWidth: "150px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                }}
                              >
                                {service.billingRemark}
                              </span>
                            </Tooltip>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.patientId}</TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.patientName}</TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.procedureName}</TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.hospitalName}</TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.referralUserName}</TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.gross}</TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.mci}</TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.yieldAmount?.toFixed(2)}</TableCell>
                        <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.totalAmount}</TableCell>
                        {roleCode === 'ACCADMIN' && (
                          <TableCell style={{ fontSize: "13px", fontWeight: 500 }}>{service.approvedBy}</TableCell>
                        )}
                        <TableCell style={{ fontSize: "15px", fontWeight: 500 }}>
                          <span style={getBillingStyle(service.billingStatus)}>
                            {getBillingStatusLabel(service.billingStatus)}
                          </span>
                        </TableCell>
                        <TableCell>{renderTraumaStatus(service.traumaStatus)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Divider />
              <div className="bg-white"></div>
            </div>
          )}
        </Sidebar>
      </div>
      <PatientSearch
        showbar={patientSearch}
        setshowBar={toggleSidebarFilter}
        onSelect={handleSelectedData}
      />
      <Sidebar
        header="Reason For Rejection"
        style={{ width: "30%", borderBottom: "1px solid #ccc" }}
        dismissable={false}
        visible={reject}
        onHide={() => setReject(false)}
        position="right"
      >
        <div className="flex grid grid-cols-1">
          <TextField
            multiline
            placeholder="Enter the Reason"
            disabled={selectedRow?.billingStatus === 6 || selectedRow?.billingStatus === 5}
            id="reasonForReject"
            name="reasonForReject"
            value={selectedRow?.reasonForReject || ''}
            onChange={(e) => rejectTionUpdate(e, selectedRow)}
          />
        </div>
        {selectedRow?.billingStatus !== 6 && selectedRow?.billingStatus !== 5 && (
          <button
            className="w-32 h-9 mt-10 bg-[#004172] text-white rounded-full"
            onClick={() => handleRejectClick(selectedRow, "R")}
          >
            Reject
          </button>
        )}
      </Sidebar>
    </OurLayouts>
  );
};

export default ServicesList;